<section class="followup-button__section">
  <div class="followup-button__container">
    <div class="followup-button__text">
      @if (title && isFirstSection) {
        <h1 class="followup-button__text__title" [bindHTML]="title"></h1>
      }
      @if (title && !isFirstSection) {
        <h2 class="followup-button__text__title" [bindHTML]="title"></h2>
      }
      @if (description) {
        <div
          class="followup-button__text__description"
          [bindHTML]="description"
        ></div>
      }
    </div>
    <div class="followup-button__button-wrapper">
      @if (!preparedLink.urlObject) {
        <a
          class="followup-button__text__button"
          [routerLink]="[preparedLink.url]"
          >{{ buttonText }}</a
        >
      } @else {
        <a class="followup-button__text__button" [href]="preparedLink.url">{{
          buttonText
        }}</a>
      }
    </div>
  </div>
</section>
